module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjUgNlYzLjVDMTAuNSAyLjY3MjEzIDkuODI3ODcgMiA5IDJINUM0LjE3MjEzIDIgMy41IDIuNjcyMTMgMy41IDMuNVYxMi41QzMuNSAxMy4zMjg0IDQuMTcxNTcgMTQgNSAxNEg5QzkuODI3ODcgMTQgMTAuNSAxMy4zMjc5IDEwLjUgMTIuNVYxME04IDZMNiA4TTYgOEw4IDEwTTYgOEgxNC41IiBzdHJva2Utd2lkdGg9IjEuMzMzMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlPSIjRjQzRjVFIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my/logout.svg
// module id = BMqg
// module chunks = 1